var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelIconTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D72929",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h17v17H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M8.594 16.216c-4.364 0-7.913-3.552-7.913-7.919C.681 3.931 4.23.379 8.594.379c4.362 0 7.912 3.552 7.912 7.918 0 4.367-3.55 7.919-7.912 7.919zm0-14.397c-3.57 0-6.475 2.905-6.475 6.478s2.905 6.479 6.475 6.479c3.569 0 6.474-2.906 6.474-6.479s-2.905-6.478-6.474-6.478zM8.56 7.155l-3.053 3.088-1.022-1.012L8.548 5.12l4.148 4.105-1.012 1.024L8.56 7.155z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelIconTop);
export default __webpack_public_path__ + "static/media/wheel-icon-top.8cd480409f793458f98aa0dbb1c1b2b1.svg";
export { ForwardRef as ReactComponent };